import './styles/main.css';
import './styles/vhs-effect.css';
import { DATA_BASE } from './core/config';
import type { SiteData } from './core/types';
import { isTouchDevice, onReady } from './core/utils';
import { ParticleGalaxy } from './ui/particle-galaxy';
import { NpcArena } from './pixi/npc-arena';
import { initNavigation } from './ui/navigation';
import { initLanguage, applyTranslations } from './ui/language';
import { initModals } from './ui/modals';
import { initCarousels } from './ui/carousels';
import { renderSections } from './ui/sections';
import { initGlitchEffect } from './ui/glitch-effect';
import { VhsNoise } from './ui/vhs-noise';

const loadData = async (): Promise<SiteData> => {
  const [team, projects, techStack, platforms] = await Promise.all([
    fetch(`${DATA_BASE}/team.json`).then((res) => res.json()),
    fetch(`${DATA_BASE}/projects.json`).then((res) => res.json()),
    fetch(`${DATA_BASE}/tech-stack.json`).then((res) => res.json()),
    fetch(`${DATA_BASE}/platforms.json`).then((res) => res.json()),
  ]);
  return { team, projects, techStack, platforms };
};

const initScrollReveal = (): void => {
  const sections = document.querySelectorAll('.section');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );
  sections.forEach((section) => observer.observe(section));
};


onReady(async () => {
  initNavigation();
  initLanguage();
  initModals();

  const data = await loadData();
  renderSections(data);
  initCarousels(data.platforms, data.techStack);
  applyTranslations();
  initScrollReveal();
  initGlitchEffect();

  const heroCanvas = document.getElementById('hero-particle-canvas') as HTMLCanvasElement | null;
  if (heroCanvas) {
    new ParticleGalaxy(heroCanvas);
  }

  const npcContainer = document.getElementById('npc-arena-container');
  if (npcContainer) {
    const arena = new NpcArena();
    arena.init(npcContainer);
  }

  if (!isTouchDevice()) {
    document.querySelectorAll<HTMLElement>('.team-card, .project-card, .video-card').forEach((card) => {
      new VhsNoise(card);
    });
  }
});
